import React from 'react';
import ViewCustomerComponent from '../../../Components/Customer/ViewCustomer';

export default function ViewCustomer() {
    return (
        <div className='page-body'>
            <ViewCustomerComponent />
        </div>
    );
}